module.exports = __webpack_public_path__ + "img/category-skill-game-hover.f828b921.png";